import { resolveStorageUrl } from "utils"
import { dhFoodsStorage } from "./api"

const endpoint = "/image"

export const uploadImage = async (
  data,
  imageCategory,
  onUploadProgress, source = { token: null }
) => {

  const response =
    await dhFoodsStorage.post(
      `${endpoint}?imageCategory=${imageCategory}`,
      data,
      {
        cancelToken: source.token,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress
      }
    )

  return {
    ...response.data,
    storagePath: response.data.url,
    url: response.data.fullUrl || resolveStorageUrl(response.data.url)
  }
}

export const downloadBillImage = async url => {
  const response =
    await dhFoodsStorage.get(
      resolveStorageUrl(url),
      { responseType: "arraybuffer" }
    )

  return response
}
